<template>
  <div>
    <validation-observer v-slot="{ invalid }">
      <v-form>
        <v-card>
          <v-card-title>荷姿</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="名称"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="packing.name"
                    :error-messages="errors"
                    label="名称"
                    hide-details="auto"
                    persistent-placeholder
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="コード"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="packing.code"
                    :error-messages="errors"
                    label="コード"
                    hide-details="auto"
                    persistent-placeholder
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  name="表示順"
                  rules="required|numeric|min_value:0|max_value:2147483647"
                >
                  <v-text-field
                    v-model="packing.position"
                    :error-messages="errors"
                    :show-size="1000"
                    label="表示順"
                    hide-details="auto"
                    persistent-placeholder
                    required
                    reverse
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              :disabled="invalid"
              @click="registerButtonClickEvent"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </div>
</template>

<script>

export default {
  name: 'AdminMasterPackingForm',
  components: {},
  mixins: [],
  data () {
    return {
      packing: {
        id: null,
        code: null,
        name: null,
        position: 0,
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.packing = {
        id: 1,
        code: '01',
        name: 'バラ',
        position: 1,
        created_at: 1633314402,
        updated_at: 1633314402,
      }
    }
  },
  methods: {
    registerButtonClickEvent () {
      this.$router.push({name: 'AdminMasterPackings'})
    }
  }
}
</script>

<style scoped>

</style>
